module.exports = __webpack_public_path__ + "img/float-full.110f5173.svg";